import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from './store.js';
import axios from 'axios'

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: "*",
      meta: {
        public: true
      },
      redirect: {
        path: "/404"
      }
    },
    {
      path: "/404",
      meta: {
        public: true,
      },
      name: "NotFound",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/NotFound.vue`
        )
    },
    {
      path: "/403",
      meta: {
        public: true
      },
      name: "AccessDenied",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/NotFound.vue`
        )
    },
    {
      path: "/500",
      meta: {
        public: true
      },
      name: "ServerError",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/NotFound.vue`
        )
    },
     {
      path: "/sso/:id",
      meta: {
        public: true
      },
      name: "ServerSSO",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sso.vue`
        )
    },
    {
      path: "/",
      meta: {
        public: true,
        permissions: [
          {
            role: "guest",
            access: true,
            redirect: 'login'
          },
          {
            role: "Cliente",
            access: false,
            redirect: "blanco"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "blanco"
          },
          {
            role: "Grupo",
            access: false,
            redirect: "admin"
          },
          {
            role: "Super Usuario",
            access: false,
            redirect: "admin"
          },

        ]
      },
      name: "login",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Login.vue`
        )
    },

    {
      path: "/home",
      meta: {
        //windowRedirectAfter: true,
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: true,
          },
          {
            role: "Super Usuario",
            access: (user, to) => user.id_cliente > 0,
            redirect: "listaclientes"
          },

        ],
      },
      name: "home",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Home.vue`
        )
    },
    {
      path: "/blanco",
      meta: {
        //windowRedirectAfter: true,
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: true,
          },
          {
            role: "Super Usuario",
            access: (user, to) => user.id_cliente > 0,
            redirect: "listaclientes"
          },

        ],
      },
      name: "blanco",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Blanco.vue`
        )
    },
    {
      path: "/vacio",
      meta: {
        //windowRedirectAfter: true,
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: true,
          },

        ],
      },
      name: "Vacio",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Vacio.vue`
        )
    },
    {
      path: "/admin",
      meta: {
        permissions: [

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },


        ],
      },
      name: "admin",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Admin.vue`
        )
    },

    {
      path: "/index",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "index",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Index.vue`
        )
    },
    {
      path: "/indexsa24",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "indexsa24",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/IndexSa24.vue`
        )
    },
    {
      path: "/indext",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "indext",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/IndexT.vue`
        )
    },
    {
      path: "/indexm",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "indexm",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/IndexM.vue`
        )
    },
    {
      path: "/indexAA",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: true,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "indexAA",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/IndexAA.vue`
        )
    },
    {
      path: "/indexAAC",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: true,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "indexAAC",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/IndexAAC.vue`
        )
    },
    {
      path: "/edrivet",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "edrivet",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/Edrive.vue`
        )
    },
    {
      path: "/carta_porte/layoutcfdi",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "carta_porte/layoutcfdi",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/ReporteLayout.vue`
        )
    },
    {
      path: "/reset/:id",
      meta: { public: true },
      name: "components/reset",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Reset.vue`
        )
    },


    {
      path: "/usuarios/change",
      meta: {

        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/change",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Change.vue`
        )
    },
    {
      path: "/listaclientes",
      meta: {

        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: true,
            redirect: "listaclientes"
          },
          {
            role: "Super Usuario",
            access: true,
            redirect: "listaclientes"
          },
          {
            role: "Soporte",
            access: true,
            redirect: "listaclientes"
          },
          {
            role: "Grupo",
            access: true,
            redirect: "listaclientes"
          },
        ],
        breadcrumb: true
      },
      name: "listaclientes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/ListaClientes.vue`
        )
    },
    {
      path: "/listagrupos",
      meta: {

        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: true,
            redirect: "listagrupos"
          },
          {
            role: "Super Usuario",
            access: true,
            redirect: "listagrupos"
          },
          {
            role: "Soporte",
            access: true,
            redirect: "listagrupos"
          },
          {
            role: "Grupo",
            access: true,
            redirect: "listagrupos"
          },
        ],
        breadcrumb: true
      },
      name: "listagrupos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/ListaGrupos.vue`
        )
    },
    {
      path: "/listaclientest",
      meta: {

        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "login"
          },
          {
            role: "Super Usuario",
            access: false,
            redirect: "login"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "login"
          },
          {
            role: "Grupo",
            access: true,
            redirect: "listaclientest"
          },
        ],
        breadcrumb: true
      },
      name: "listaclientest",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/ListaClientesTransporte.vue`
        )
    },
    {
      path: "/catalogos/grupos",
      meta: {

        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: true,
            redirect: "home"
          },
          {
            role: "Super Usuario",
            access: true,
            redirect: "components/grupos"
          },
          {
            role: "Soporte",
            access: true,
            redirect: "home"
          },
          {
            role: "Grupo",
            access: true,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: "components/grupos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Grupos.vue`
        )
    },
    {
      path: "/apendices/bancos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "apendices/bancos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/apendices/AP_bancos.vue`
        )
    },
    {
      path: "/catalogos/aduanas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "aduanas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Aduanas.vue`
        )
    },
    {
      path: "/catalogos/embarcadores",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "embarcadores",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EmbarcadorConsignatario.vue`
        )
    },
    {
      path: "/catalogos/agentescarga",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "agentescarga",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/AgentesDeCarga.vue`
        )
    },
    {
      path: "/catalogos/transportistas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "catalogos/transportistas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Transportistas.vue`
        )
    },
    {
      path: "/catalogos/agentes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "agentes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Agentes.vue`
        )
    },
    {
      path: "/catalogos/erroresws",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "erroresws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Erroresws.vue`
        )
    },
    /*{
      path: "/catalogos/configuracion",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "configuracion",
      component: () =>
        import(
          `@/views/catalogos/Configuracion.vue`
        )
    },*/
    {
      path: "/configuracion/politicas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "politicas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Politicas.vue`
        )
    },
    {
      path: "/politica_privacidad",
      meta: {
        breadcrumb: false
      },
      name: "politica_privacidad",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Politica_Privacidad.vue`
        )
    },
    {
      path: "/catalogos/tipos_empresas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "tipos_empresas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/TiposEmpresas.vue`
        )
    },
    {
      path: "/catalogos/tipos_servicios",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "tipos_servicios",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/TiposServicios.vue`
        )
    },
    {
      path: "/catalogos/urls",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "tipos_urls",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/TiposUrls.vue`
        )
    },
    {
      path: "/catalogos/estados_ws",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "estados_ws_catalogo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EstadosWS.vue`
        )
    },
    {
      path: "/catalogos/empresasimmex",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "empresasimmex",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EmpresasIMMEX.vue`
        )
    },
    {
      path: "/servicedesk/tickets",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "tickets",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/servicedesk/Tickets.vue`
        )
    },
    {
      path: "/servicedesk/proyectos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "proyectos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/servicedesk/Proyectos.vue`
        )
    },
    {
      path: "/catalogos/representantes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "representantes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Representantes.vue`
        )
    },
    {
      path: "/catalogos/referencias",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "referencias",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/ClientesReferencias.vue`
        )
    },
    {
      path: "/catalogos/pedimento_referencia",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "pedimento_referencias",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/ClientesReferenciasPedimentos.vue`
        )
    },
    {
      path: "/catalogos/pagos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: "pagos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/Pagos.vue`
        )
    },
    {
      path: "/catalogos/permisos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: "permisos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Permisos.vue`
        )
    },
    {
      path: "/clientes/domicilio",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "domicilio",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Domicilio.vue`
        )
    },
      {
      path: "/clientes/domicilio2",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "domicilio2",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Domicilio.vue`
        )
    },
    {
      path: "/clientes/vinculados",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "vinculados",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Vinculados.vue`
        )
    },
    {
      path: '/usuarios/registro',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'usuarios/Registro',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/usuarios/Registro.vue`
      )
    },
    {
      path: '/view_pedimento/:id_etiqueta/:id_pedimento',
      meta: {
        public: true,
      },
      name: 'view_pedimento',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/reportes_activo_fijo/ViewPedimento.vue`
      )
    },
    {
      //Url especial para los QR de BOSCH
      path: '/view_pedimento/:id_etiqueta/:id_pedimento/:id_etiqueta_pedimento_bosch',
      meta: {
        public: true,
      },
      name: 'view_pedimento_bosh',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/reportes_activo_fijo/ViewPedimento.vue`
      )
    },
    {
      //Url especial para los QR de Activo Fijo Nacional
      path: '/af_nacional/:rfc_empresa/:id_activo_fijo_nacional',
      meta: {
        public: true,
      },
      name: 'af_nacional',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/reportes_activo_fijo/ViewAFNacional.vue`
      )
      },


    {
      path: '/usuariost',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
          {
            role: "Super Usuario",
            access: false,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "admin"
          },
          {
            role: "Grupo",
            access: true,
            redirect: "usuariost"
          },
        ],
        breadcrumb: true
      },
      name: 'usuariostransportista',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosTransporte.vue`
      )
    },


    {
      path: '/catalogos/usuariosAdmin',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuariosAdmin',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosAdmin.vue`
      )
    },
    {
      path: '/catalogos/usuariosAdminGrupo',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuariosAdminGrupo',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosAdminGrupo.vue`
      )
    },
    {//Catalogo de usuarios_clientes que puede ver el Super Admin
      path: '/catalogos/usuarios_clientes',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuarios_clientes',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosClientes.vue`
      )
    },
    {
      path: '/utilerias/configurables',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'configurables',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/utilerias/Configurables.vue`
      )
    },
    {
      path: '/utilerias/indicadores',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'indicadores',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/utilerias/Indicadores.vue`
      )
    },
    {
      path: '/utilerias/reglas_expediente_manifestacion',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'reglas_expediente_manifestacion',
      component: () => import(
        `@/views/utilerias/ReglasExpedienteManifestacion.vue`
      )
    },
    {
      path: '/utilerias/configurables_manifestacion',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'configurables_manifestacion',
      component: () => import(
        `@/views/utilerias/ConfigurablesManifestacion.vue`
      )
    },
    {
      path: '/manifestacion/bandeja_temporal',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'manifestacion-bandeja-temporal',
      component: () => import(
        `@/views/manifestacion_valor/BandejaTemporalManifestacion.vue`
      )
    },
    {
      path: '/catalogos/usuarios',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuarios',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/Usuarios.vue`
      )
    },
    {
      path: '/catalogos/usuariossa',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuariossa',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosSA.vue`
      )
    },
     {
      path: '/catalogos/usuariosmv',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuariosmv',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosMV.vue`
      )
    },
    {
      path: '/catalogos/usuariossa24',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/usuariossa24',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/UsuariosSA24.vue`
      )
    },
    {
      path: "/datastage/cargazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/cargazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/datastage/CargaZipDS.vue`
        )
    },
    {
      path: "/datastage/aa_cargazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/datastage/aa_cargazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/datastage/AACargaZipDS.vue`
        )
    },
    {
      path: "/vucemaa/recuperaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/vucem/recuperaciones_m",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/vucem/RecuperacionesM.vue`
        )
    },
    {
      path: "/vucemaa/recuperaciones_agentes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/vucem/recuperaciones_aa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/vucem/RecuperacionesAA.vue`
        )
    },
    {
      path: "/vucemaa/consultar_coves_m",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/vucem/consultar_coves_m",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/vucem/ConsultarCovesM.vue`
        )
    },
    {
      path: "/vucemaa/consultar_pedimentos_agentes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/vucem/consultar_pedimentos_agentes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/vucem/ConsultarPedimentosAgentes.vue`
        )
    },
    {
      path: "/vucemaa/consultar_edocs_m",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/vucem/consultar_edocs_m",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/vucem/ConsultarEdocsM.vue`
        )
    },
    {
      path: "/datastage/aa_bitacorazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/datastage/aa_bitacorazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/datastage/AABitacoraZip.vue`
        )
    },
    {
      path: "/datastage/predeterminadosds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/datastage/predeterminadosds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/datastage/PredeterminadosDS.vue`
        )
    },
    {
      path: "/e-drive/:ekey/:pedimento",
      meta: {
        public: true
      },
      name: "e-drive",
      component: () =>
        import(
          `@/views/edrive/eDrive.vue`
        )
    },
    {
      path: "/datastage/aa_directo_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/aa_directo_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/datastage/AAReporteDirectoDS.vue`
        )
    },
    {
      path: "/cargar_adjuntos_pedimento",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/cargar_adjuntos_pedimento",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/CargaZipAdjuntosPedimento.vue`
        )
    },
    {
      path: "/adjuntos_pedimento_aa",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/adjuntos_pedimento_aa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/CargaZipAdjuntosPedimentoAA.vue`
        )
    },
    {
      path: "/cargar_adjuntos_trafico",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/cargar_adjuntos_trafico",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/CargaZipAdjuntosTrafico.vue`
        )
    },
    {
      path: "/consulta_adjuntos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/consulta_adjuntos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/ConsultaAdjuntos.vue`
        )
    },
    {
      path: "/consulta_adjuntos_aa",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/consulta_adjuntos_aa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/ConsultaAdjuntosAA.vue`
        )
    },
    {
      path: "/expediente_pedimento",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/expediente_pedimento",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/ExpedientePedimento.vue`
        )
    },
    {
      path: "/expediente_pedimentoaa",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/expediente_pedimentoaa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/ExpedientePedimentoAA.vue`
        )
    },
    {
      path: "/datastage/bitacorazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/bitacorazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/datastage/BitacoraZip.vue`
        )
    },
    {
      path: "/datastage/directo_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/directo_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/datastage/ReporteDirectoDS.vue`
        )
    },
    {
      path: "/vucem/recuperacionesws",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/recuperacionesws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/RecuperacionesWS.vue`
        )
    },
    {
      path: "/reportes/rpt_contribuciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_contribuciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/layout_contribuciones/ReportesContribuciones.vue`
        )
    },
    {
      path: "/reportes/rpt_contribuciones_admin",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_contribuciones_admin",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/layout_contribuciones/ContribucionesAdmin.vue`
        )
    },
    {
      path: "/reportes/rpt_preferencias",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_preferencias",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/RptPreferenciasYazaki.vue`
        )
    },
    {
      path: "/reportes/rpt_layout_bosch",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_layout_bosch",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/RptLayoutBosch.vue`
        )
    },
    {
      path: "/reportes/rpt_layout_agrocentro",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_layout_agrocentro",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/RptLayoutAgrocentro.vue`
        )
    },
    {
      path: "/reportes/rpt_layout2_bosch",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_layout2_bosch",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/RptLayout2Bosch.vue`
        )
    },
    {
      path: "/reportes/rpt_cruce_bosch",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/rpt_cruce_bosch",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/RptLayoutCruceBosch.vue`
        )
    },
    {
      path: "/reportes/af_nacional",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/af_nacional",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/AFNacional.vue`
        )
    },
    {
      path: "/importaciones/layout_confronta_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "importaciones/layout_confronta_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/formatos/LayoutA24.vue`
        )
    },
    {
      path: "/reportes/detalles_confronta_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/detalles_confronta_ds",
      component: () =>
        import(
          `@/views/reportes/LayoutA24Detalle.vue`
        )
    },
    {
      path: "/reportes/resumen_confronta_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes/resumen_confronta_ds",
      component: () =>
        import(
          `@/views/reportes/LayoutA24Resumen.vue`
        )
    },
    {
      path: "/vucem/evidencias",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "evidencias",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/Evidencias.vue`
        )
    },
    {
      path: "/vucem/diagnosticovucem",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/diagnosticovucem",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/DiagnosticoVucem.vue`
        )
    },
    {
      path: "/vucem/documents_creados",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/documents_creados",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/DocumentsCreados.vue`
        )
    },
    {
      path: "/vucem/directo_ws",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/directo_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/ReporteDirectoWS.vue`
        )
    },
    {
      path: "/transmision/cove",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/transmision-cove",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-transmision/Cove.vue`
        )
    },
    {
      path: "/transmision/covedetalles",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/transmision-covedetalles",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-transmision/CoveDetalles.vue`
        )
    },
    {
      path: "/transmision/edocument",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/transmision-edocument",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-transmision/Edocument.vue`
        )
    },
    {
      path: "/vucem/adjuntar_edocument",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/adjuntar_edocument",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/AdjuntarEdocuments.vue`
        )
    },
    {
      path: "/vucem/adjuntar_edocument_aa",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/adjuntar_edocument_aa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/AdjuntarEdocumentsAA.vue`
        )
    },
    {
      path: "/vucem/layout",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/layoutvucem",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/SolicitudLayout.vue`
        )
    },
    {
      path: "/vucemaa/layout",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/layoutvucem_agentesaduanales",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/agentes_aduanales/vucem/SolicitudLayoutAA.vue`
        )
    },
    {
      path: "/vucem/diaria",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/consultadiaria",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/ConsultaDiaria.vue`
        )
    },
    {
      path: "/catalogos/terminos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/terminos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Terminos.vue`
        )
    },
    {
      path: "/notificaciones/enviadas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "components/notificacionesEnviadas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/notificaciones/NotificacionesEnviadas.vue`
        )
    },
    {
      path: "/catalogos/logsistema",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "logsistema",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/LogSistema.vue`
        )
    },
    {
      path: "/catalogos/logviews",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "logviews",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/LogViews.vue`
        )
    },
    {
      path: "/catalogos/acceso_usuarios",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "acceso_usuarios",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/AccesoUsuarios.vue`
        )
    },
    {
      path: "/catalogos/avisos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "avisos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Avisos.vue`
        )
    },
    {
      path: "/catalogos/logsistemausuario",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "logsistemausuario",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/LogSistemaUsuario.vue`
        )
    },
    {
      path: '/catalogos/perfiles',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/perfiles',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/Perfiles.vue`
      )
    },
    {
      path: '/clientes/aduanas',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'aduanascliente',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/clientes/AduanasCliente.vue`
      )
    },
    {
      path: '/catalogos/clientes',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/clientes',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/Clientes.vue`
      )
    },
    {
      path: '/empresas_timer',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: 'components/timer',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/catalogos/TimerClientes.vue`
      )
    },
    {
      path: "/catalogos/emisores_destinatarios",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "emisores_destinatarios",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EmisoresDestinatarios.vue`
        )
    },
    {
      path: "/catalogos/rfc_consulta",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "rfc_consulta",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/RFCConsulta.vue`
        )
    },
    {
      path: "/catalogos/mercancias",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mercancias",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Mercancias.vue`
        )
    },
    {
      path: "/notificaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "notificaciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/notificaciones/Notificaciones.vue`
        )
    },
    {
      path: "/admin/keys_sftp",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "keys_sftp",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/KeysSFTP.vue`
        )
    },
    {
      path: "/clientes/certificados",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "certificados",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/PanelSellos.vue`
        )
    },
      {
      path: "/clientes/certificados2",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "certificados2",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/PanelSellos.vue`
        )
    },
    {
      path: "/clientes/certificaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "certificaciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/Certificaciones.vue`
        )
    },
    {
      path: "/clientes/datos_contribuyente",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "datos_contribuyente",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/DatosContribuyente.vue`
        )
    },
    {
      path: "/agentes/certificadosagentes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "certificadosagentes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/PanelSellosAgentes.vue`
        )
    },
    {
      path: "/clientes/firmas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "firmas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/clientes/Firmas.vue`
        )
    },
    {
      path: "/usuarios/perfil",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "perfil_usuario",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Perfil.vue`
        )
    },
    {
      path: "/apendices/certificaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap_certificaciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/apendices/ap_certificaciones.vue`
        )
    },
    {
      path: "/apendices/ap_agentes_admin",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap_agentes_admin",
      component: () =>
        import(
          `@/views/apendices/AP_agentes_aduanales_admin.vue`
        )
    },
    {
      path: "/apendices/importadores",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap_importadores",
      component: () =>
        import(
          `@/views/apendices/AP_PadronImportadores.vue`
        )
    },
    {
      path: "/apendices/ap_transportistas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap_transportistas",
      component: () =>
        import(
          `@/views/apendices/AP_transportistas.vue`
        )
    },
    {
      path: "/apendices/01",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap01",
      component: () =>
        import(
          `@/views/apendices/01_ap_medios_transporte.vue`
        )
    },
    {
      path: "/apendices/02",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap02",
      component: () =>
        import(
          `@/views/apendices/02_ap_unidades_medida.vue`
        )
    },
    {
      path: "/apendices/03",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap03",
      component: () =>
        import(
          `@/views/apendices/03_ap_tipo_contenedores.vue`
        )
    },
    {
      path: "/apendices/04",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap04",
      component: () =>
        import(
          `@/views/apendices/04_ap_claves_valoracion.vue`
        )
    },
    {
      path: "/apendices/05",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap05",
      component: () =>
        import(
          `@/views/apendices/05_ap_formas_pago.vue`
        )
    },
    {
      path: "/apendices/06",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap06",
      component: () =>
        import(
          `@/views/apendices/06_ap_destinos_mercancias.vue`
        )
    },
    {
      path: "/apendices/07",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap07",
      component: () =>
        import(
          `@/views/apendices/07_ap_regimenes.vue`
        )
    },
    {
      path: "/apendices/08",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap08",
      component: () =>
        import(
          `@/views/apendices/08_ap_tipos_tasas.vue`
        )
    },
    {
      path: "/apendices/09",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap09",
      component: () =>
        import(
          `@/views/apendices/09_ap_tipos_certificacion.vue`
        )
    },
    {
      path: "/apendices/10",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap10",
      component: () =>
        import(
          `@/views/apendices/10_ap_claves_moneda.vue`
        )
    },
    {
      path: "/apendices/11",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap11",
      component: () =>
        import(
          `@/views/apendices/11_ap_recintos_fiscalizados.vue`
        )
    },
    {
      path: "/apendices/12",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap12",
      component: () =>
        import(
          `@/views/apendices/12_ap_regulaciones.vue`
        )
    },
    {
      path: "/apendices/13",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap13",
      component: () =>
        import(
          `@/views/apendices/13_ap_claves_pedimento.vue`
        )
    },
    {
      path: "/apendices/14",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap14",
      component: () =>
        import(
          `@/views/apendices/14_ap_tipos_contribucion.vue`
        )
    },
    {
      path: "/apendices/15",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap15",
      component: () =>
        import(
          `@/views/apendices/15_ap_terminos_facturacion.vue`
        )
    },
    {
      path: "/apendices/16",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap16",
      component: () =>
        import(
          `@/views/apendices/16_ap_identificadores.vue`
        )
    },
    {
      path: "/apendices/17",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap17",
      component: () =>
        import(
          `@/views/apendices/17_ap_claves_paises.vue`
        )
    },
    {
      path: "/apendices/18",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap18",
      component: () =>
        import(
          `@/views/apendices/18_ap_recintos_fiscalizados.vue`
        )
    },
    {
      path: "/apendices/19",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap19",
      component: () =>
        import(
          `@/views/apendices/19_ap_secciones_aduaneras.vue`
        )
    },
    {
      path: "/apendices/20",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap20",
      component: () =>
        import(
          `@/views/apendices/20_ap_tipo_embarques.vue`
        )
    },
    {
      path: "/apendices/21",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap21",
      component: () =>
        import(
          `@/views/apendices/21_ap_tipo_operaciones.vue`
        )
    },
    {
      path: "/apendices/22",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap22",
      component: () =>
        import(
          `@/views/apendices/22_ap_claves_estados.vue`
        )
    },
    {
      path: "/apendices/23",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap23",
      component: () =>
        import(
          `@/views/apendices/23_ap_claves_municipios.vue`
        )
    },
    {
      path: "/apendices/24",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap24",
      component: () =>
        import(
          `@/views/apendices/24_ap_claves_ciudades.vue`
        )
    },
    {
      path: "/apendices/matriz_rnna",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap_matriz_rnna",
      component: () =>
        import(
          `@/views/apendices/AP_Matriz_RRNA.vue`
        )
    },
    {
      path: "/apendices/25",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap25",
      component: () =>
        import(
          `@/views/apendices/25_ap_claves_documentos.vue`
        )
    },
    {
      path: "/apendices/26",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap26",
      component: () =>
        import(
          `@/views/apendices/26_ap_relacion_regimen.vue`
        )
    },
    {
      path: "/apendices/27",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap27",
      component: () =>
        import(
          `@/views/apendices/27_ap_identificadores_activo_fijo.vue`
        )
    },
    {
      path: "/apendices/28",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap28",
      component: () =>
        import(
          `@/views/apendices/28_ap_palabras_activo_fijo.vue`
        )
    },
    {
      path: "/apendices/29",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap29",
      component: () =>
        import(
          `@/views/apendices/29_ap_tipos_proveedores.vue`
        )
    },
    {
      path: "/apendices/30",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap30",
      component: () =>
        import(
          `@/views/apendices/30_ap_destinos_aduaneros.vue`
        )
    },
    {
      path: "/apendices/31",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap31",
      component: () =>
        import(
          `@/views/apendices/31_ap_tipo_informes.vue`
        )
    },
    {
      path: "/apendices/32",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap32",
      component: () =>
        import(
          `@/views/apendices/32_ap_periodos_asociados.vue`
        )
    },
    {
      path: "/apendices/33",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap33",
      component: () =>
        import(
          `@/views/apendices/33_ap_claves_operacion_cargos.vue`
        )
    },
    {
      path: "/apendices/34",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap34",
      component: () =>
        import(
          `@/views/apendices/34_ap_regimenes_soluciona.vue`
        )
    },
    {
      path: "/apendices/35",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap35",
      component: () =>
        import(
          `@/views/apendices/35_ap_tipos_certificacion.vue`
        )
    },
    {
      path: "/apendices/36",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap35",
      component: () =>
        import(
          `@/views/apendices/36_ap_catalogos.vue`
        )
    },
    {
      path: "/apendices/38",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap38",
      component: () =>
        import(
          `@/views/apendices/38_mv_decrementables.vue`
        )
    },
    {
      path: "/apendices/39",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap39",
      component: () =>
        import(
          `@/views/apendices/39_mv_formas_pago.vue`
        )
    },
    {
      path: "/apendices/40",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap40",
      component: () =>
        import(
          `@/views/apendices/40_mv_icoterm.vue`
        )
    },
    {
      path: "/apendices/41",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap41",
      component: () =>
        import(
          `@/views/apendices/41_mv_incrementables.vue`
        )
    },
    {
      path: "/apendices/42",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap42",
      component: () =>
        import(
          `@/views/apendices/42_mv_metodos_valoracion.vue`
        )
    },
    {
      path: "/apendices/43",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap43",
      component: () =>
        import(
          `@/views/apendices/43_mv_tipo_figura.vue`
        )
    },
    {
      path: "/apendices/44",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ap44",
      component: () =>
        import(
          `@/views/apendices/44_mv_tipo_moneda.vue`
        )
    },
    
    {
      path: "/predeterminados",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "predeterminados",
      component: () =>
        import(
          `@/views/reportes/PredeterminadosDS.vue`
        )
    },
    {
      path: "/reportes/consulta_501",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "consulta_501",
      component: () =>
        import(
          `@/views/reportes_admin/Reporte501.vue`
        )
    },
    {
      path: "/reportes/consulta_501_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "consulta_501_ds",
      component: () =>
        import(
          `@/views/reportes_admin/Reporte501_DS.vue`
        )
    },
    {
      path: "/reportes/recuperaciones_usuario",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "recuperaciones_usuario",
      component: () =>
        import(
          `@/views/reportes_admin/ReporteConteoRecuperaciones.vue`
        )
    },
    {
      path: "/utilerias/lineas_captura",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "lineas_captura_admin",
      component: () =>
        import(
          `@/views/reportes_admin/LineasCapturaAdmin.vue`
        )
    },
    {
      path: "/utilerias/quick-dashboard",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "quick-dashboard",
      component: () =>
        import(
          `@/views/utilerias/Quicksight.vue`
        )
    },
    {
      path: "/utilerias/solicitud_consulta",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "solicitud_consulta_admin",
      component: () =>
        import(
          `@/views/reportes_admin/SolicitudConsultaAdmin.vue`
        )
    },
    {
      path: "/reportes/consulta_551",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "consulta_551",
      component: () =>
        import(
          `@/views/reportes_admin/Reporte551.vue`
        )
    },
    {
      path: "/reportes/consulta_551_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "consulta_551_ds",
      component: () =>
        import(
          `@/views/reportes_admin/Reporte551_ds.vue`
        )
    },
    {
      path: "/reportes/rfc_agentes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "rfc_agentes",
      component: () =>
        import(
          `@/views/reportes_admin/RfcAgentes.vue`
        )
    },
    {
      path: "/reportes/rfc_coves_agentes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "rfc_coves_agentes",
      component: () =>
        import(
          `@/views/reportes_admin/RfcCovesRemesasAgentes.vue`
        )
    },
    {
      path: "/reportes/rfc_identificadores",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "rfc_identificadores",
      component: () =>
        import(
          `@/views/reportes_admin/RfcPatenteFiltros.vue`
        )
    },
    {
      path: "/reportes/urls_visitadas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "urls_visitadas",
      component: () =>
        import(
          `@/views/reportes_admin/UrlsVisitadas.vue`
        )
    },
    {
      path: "/reportes/especiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "especiales",
      component: () =>
        import(
          `@/views/reportes/Especiales.vue`
        )
    },
    { //Reporte especial para SEWS
      path: "/reportes/armado_a24",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "armado_a24",
      component: () =>
        import(
          `@/views/reportes/ArmadoAnexo24.vue`
        )
    },
    { //Reporte especial para IEWC
      path: "/reportes/iewc_armado_a24",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "iewc_armado_a24",
      component: () =>
        import(
          `@/views/reportes/IEWCArmadoAnexo24.vue`
        )
    },
    {
      path: "/permisos_previos/nuevo_permiso",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/permisos_previos/nuevo_permiso",
      component: () =>
        import(
          `@/views/permisos_previos/NuevoPermiso.vue`
        )
    },
    {
      path: "/permisos_previos/reporteds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/permisos_previos/reporteds",
      component: () =>
        import(
          `@/views/permisos_previos/ReporteDS.vue`
        )
    },
    {
      path: "/predeterminadosws",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "predeterminadosws",
      component: () =>
        import(
          `@/views/reportes/PredeterminadosWS.vue`
        )
    },
    {
      path: "/facturas_pedimentos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "facturas_pedimentos",
      component: () =>
        import(
          `@/views/ecosting/ReporteFacturasPedimentos.vue`
        )
    },
    {
      path: "/panel_ecosting",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "panel_ecosting",
      component: () =>
        import(
          `@/views/ecosting/PanelReportes.vue`
        )
    },
    {
      path: "/bandeja_temporal",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "bandeja_temporal",
      component: () =>
        import(
          `@/views/edrive/BandejaTemporal.vue`
        )
    },
    {
      path: "/bandeja_temporal_aa",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "bandeja_temporal_aa",
      component: () =>
        import(
          `@/views/edrive/BandejaTemporalAA.vue`
        )
    },
    {
      path: "/facturas_layout",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "facturas_layout",
      component: () =>
        import(
          `@/views/ecosting/ReporteLayoutFacturasPedimentos.vue`
        )
    },
    {
      path: "/layout_p020",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "layout_p020",
      component: () =>
        import(
          `@/views/ecosting/CargaLayoutP020.vue`
        )
    },
    {
      path: "/transportes_incrementables",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "transportes_incrementables",
      component: () =>
        import(
          `@/views/reportes/ReporteTransportesIncrementables.vue`
        )
    },
    {
      path: "/informe_cruces",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "informe_cruces",
      component: () =>
        import(
          `@/views/reportes/ReporteInformeCruces.vue`
        )
    },
    {
      path: "/rectificaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "rectificaciones",
      component: () =>
        import(
          `@/views/reportes/Rectificaciones.vue`
        )
    },
    {
      path: "/graficas/detalle_grafica/:id",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "detalle_grafica",
      component: () =>
        import(
          `@/views/graficas/detalle_grafica.vue`
        )
    },
    {
      path: "/rectificaciones_arbol/:id",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "rectificaciones_arbol",
      component: () =>
        import(
          `@/views/reportes/Rectificaciones_arbol.vue`
        )
    },
    {
      path: "/reportes/facturas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reporte_facturas",
      component: () =>
        import(
          `@/views/reportes/ReporteFacturas.vue`
        )
    },
    {
      path: "/tigie",

      meta: {
        permissions: [

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "tigie",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/tigie/ConsultaTigie.vue`
        )
    },
    {
      path: "/DOF",

      meta: {
        permissions: [

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "DOF",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/tigie/DOF.vue`
        )
    },
    {
      path: "/tigiews",


      name: "tigiews",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/tigie/ConsultaTigieWS.vue`
        )
    },
    {
      path: "/trafico",

      meta: {
        permissions: [

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "trafico",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/Trafico.vue`
        )
    },
    {
      path: "/nuevo_trafico",
      meta: {
        permissions: [

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "nuevo_trafico",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/NuevoTraficoComponent.vue`
        )
    },
    {
      path: "/trafico_index",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "trafico_index",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/TraficoIndex.vue`
        )
    },
    {
      path: "/trafico_reportes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "trafico_reportes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/TraficoReportes.vue`
        )
    },
    {
      path: "/trafico/reporte_embarques",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/trafico/reporte_embarques",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/ReporteEmbarquesGrupo.vue`
        )
    },
    {
      path: "/configurar_estados",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "configurar_estados",
      component: () =>
        import(
          `@/views/trafico/ConfigurarEstados.vue`
        )
    },
    {
      path: "/configurar_columnas",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "configurar_columnas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/ConfigurarColumnas.vue`
        )
    },
    {
      path: "/trafico/expediente",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "trafico_expediente",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/components/trafico/Expediente.vue`
        )
    },
    {
      path: "/catalogos/templates",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "templates",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Templates.vue`
        )
    },
    {
      path: "/traficos/solicitud_devolucion_garantia",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "tafico_solicitud_devolucion_garantia",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/SolicitudDevolucionGarantia.vue`
        )
    },
    {
      path: "/traficos/solicitud_pago_garantia",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "tafico_solicitud_pago_garantia",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/SolicitudPagoGarantia.vue`
        )
    },
    {
      path: "/traficos/solicitud_cuenta_aduanera",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "tafico_solicitud_cuenta_aduanera",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/trafico/SolicitudCuentaAduanera.vue`
        )
    },
    {
      path: "/reportes/transmitted_edocs",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/transmitted_edocs",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/TransmisionEdocs.vue`
        )
    },
    {
      path: "/reportes/transmitted_coves",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/transmitted_coves",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/TransmisionCoves.vue`
        )
    },
    {
      path: "/reportes/consultar_edocuments_ws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_edocuments_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsultarEdocumentsWS.vue`
        )
    },
    {
      path: "/mv_consultar_coves",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/mv_consultar_coves",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/ConsultarCove.vue`
        )
    },
    {
      path: "/mv_consultar_edocs",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_edocs_maifestacion",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/ConsultarEdocs.vue`
        )
    },
    {
      path: "/reportes/consultar_coves_ws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_coves_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsultarCoveWS.vue`
        )
    },
    {
      path: "/reportes/consultar_remesas_ws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_remesas_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsultarRemesasWS.vue`
        )
    },
    {
      path: "/reportes/facturas_afn",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/facturas_afn",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/FacturasAFNacional.vue`
        )
    },
    {
      path: "/reportes/consultar_estados_ws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_estados_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsultarEstadosWS.vue`
        )
    },
    {
      path: "/reportes/consultar_pedimentos_ws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_pedimentos_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsultarPedimentosWS.vue`
        )
    },
    {
      path: "/reportes/consultar_pedimentos_detalle",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_pedimentos_detalle",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/ConsultaPedimentoSimple.vue`
        )
    },
    {
      path: "/reportes/consultar_acuses_ws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consultar_acuses_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsultarAcusesWS.vue`
        )
    },
    {
      path: "/vucem/bitacora_ws",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "bitacora_ws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/BitacoraWS.vue`
        )
    },
    {
      path: "/vucem/confronta_ws_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "confronta_ws_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConfrontaWSDS.vue`
        )
    },
    {
      path: "/catalogos/equestions",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: "equestions",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Equestions.vue`
        )
    },
    {
      path: "/catalogos/etips",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
          {
            role: "Cliente",
            access: false,
            redirect: "home"
          },
        ],
        breadcrumb: true
      },
      name: "etips",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Etips.vue`
        )
    },
    {
      path: "/catalogos/etipsHTML",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "etipsHTML",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EtipsHTML.vue`
        )
    },
    {
      path: "/catalogos/etipsHTMLSa31",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "etipsHTMLSa31",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EtipsHTMLSA.vue`
        )
    },
    {
      path: "/catalogos/etipsHTMLSa31PF",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "etipsHTMLSa31PF",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EtipsHTMLSAPF.vue`
        )
    },
    {
      path: "/catalogos/enotes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "enotes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/EnotesHTML.vue`
        )
    },
    {
      path: "/edrive/explorer",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "explorer",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/Explorer.vue`
        )
    },
    {
      path: "/edrive/exploreraa",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "exploreraa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/ExplorerAA.vue`
        )
    },
    {
      path: "/mv_edrive",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_edrive",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/Edrive.vue`
        )
    },
    {
      path: "/edrive/explorer_peticiones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "explorer_peticiones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/ExplorerPeticiones.vue`
        )
    },
    {
      path: "/reportes/personalizados_admin",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "personalizados_admin",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/PersonalizadosAdmin.vue`
        )
    },
    {
      path: "/reportes_cuentas_aduaneras/cuentasWS",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cuentasWS",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/CuentasAduanerasGarantiaWS.vue`
        )
    },
    {
      path: "/reportes_cuentas_aduaneras/cuentasDS",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cuentasDS",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/CuentasAduanerasGarantiaDS.vue`
        )
    },
    {
      path: "/vucem-pedimento/qr",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "qr",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/ConsultaRapida.vue`
        )
    },
    {
      path: "/manifestacion/expediente",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/manifestacion/expediente",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/ExpedienteManifestacion.vue`
        )
    },
    {
      path: "/manifestacion/transmitir",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/manifestacion/transmitir",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/TransmitirManifestacion.vue`
        )
    },
     {
      path: "/manifestacion/canceladas",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/manifestacion/canceladas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/CanceladasManifestacion.vue`
        )
    },
    {
      path: "/mv_bitacora_ly",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/mv_bitacora_ly",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/LogCargaManifestacion.vue`
        )
    },
  
    {
      path: "/manifestacion/directo_archivom",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/manifestacion/directo_archivom",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/ReporteDirectoArchivoM.vue`
        )
    },
    {
      path: "/formatos/hc_consulta",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/formatos/hc_consulta",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/formatos/HojaCalculoConsulta.vue`
        )
    },
    {
      path: "/formatos/hc_formato/:id",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/formatos/hc_formato",
      component: () =>
        import(
          `@/views/formatos/HojaCalculoFormato.vue`
        )
    },
    {
      path: "/formatos/mv_consulta",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/formatos/mv_consulta",
      component: () =>
        import(
          `@/views/formatos/ManifestacionConsulta.vue`
        )
    },
    {
      path: "/formatos/mv_formato/:id",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/formatos/mv_formato",
      component: () =>
        import(
          `@/views/formatos/ManifestacionFormato.vue`
        )
    },
    {
      path: "/vucem/lineas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "lineas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/ConsultarLineas.vue`
        )
    },
    {
      path: "/vucem/estados_soia",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "estados_soia",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/ConsultarEstados.vue`
        )
    },
    {
      path: "/vucem/auditoria_lineas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "auditoria_lineas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/AuditoriaLineas.vue`
        )
    },
    {
      path: "/graficas/contribuciones",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/graficas/contribuciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/graficas/contribuciones_grafica.vue`
        )
    },
    {
      path: "/graficas/pedimentos_patentes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/graficas/pedimentos_patentes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/graficas/pedimentos_patentes.vue`
        )
    },
    {
      path: "/graficas/pedimentos_patentes_ds",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/graficas/pedimentos_patentes_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/graficas/pedimentos_patentes_ds.vue`
        )
    },
    {
      path: "/graficas/pedimentos_transportes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/graficas/pedimentos_transportes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/graficas/pedimentos_transportes.vue`
        )
    },

    /* graficas para grupo */
    {
      path: "/grupo/graficas/pedimentos_patentes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/graficas/pedimentos_patentes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/graficas/pedimentos_patentes.vue`
        )
    },


    {
      path: "/grupo/graficas/pedimentos_patentes_ds",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/graficas/pedimentos_patentes_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/graficas/pedimentos_patentes_ds.vue`
        )
    },



    {
      path: "/grupo/graficas/pedimentos_transportes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/graficas/pedimentos_transportes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/graficas/pedimentos_transportes.vue`
        )
    },


    {
      path: "/reportes/informacion_activo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/informacion_activo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_activo_fijo/InformacionContenido.vue`
        )
    },
    {
      path: "/reportes/activofijo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/activofijo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_activo_fijo/ActivoFijo.vue`
        )
    },
    {
      path: "/reportes/layouts_activofijo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/layouts_activofijo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_activo_fijo/LayoutsActivoFijo.vue`
        )
    },
    {
      path: "/reportes/etiquetas_activofijo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/etiquetas_activofijo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_activo_fijo/EtiquetasQRGeneral.vue`
        )
    },
    {
      path: "/reportes/qr_af_nacional",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/qr_af_nacional",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_activo_fijo/ActivoFijoNacionalQR.vue`
        )
    },
    {
      path: "/reportes/etiquetas_bosch",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/etiquetas_bosch",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_activo_fijo/EtiquetasQRBosch.vue`
        )
    },
    {
      path: "/reportes/contribuciones",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/contribuciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/Contribuciones.vue`
        )
    },
    {
      path: "/reportes/consolidado_balluf",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/consolidado_balluf",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ConsolidadoBalluf.vue`
        )
    },
    {
      path: "/reportes/rpt_facturas_balluf",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/rpt_facturas_balluf",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes_balluf/CargaLayoutFacturas.vue`
        )
    },
    {
      path: "/reportes/layout_proforma",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/layout_proforma",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/LayoutProforma.vue`
        )
    },
    {
      path: "/reportes/identificadores_complementos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/identificadores_complementos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/IdentificadoresComplementos.vue`
        )
    },
    {
      path: "/reportes/identificadores_auditoria",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/identificadores_auditoria",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ReporteIdentificadoresAuditoria.vue`
        )
    },
    {
      path: "/reportes/auditoria_rrna",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/auditoria_rrna",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/AuditoriaRRNA.vue`
        )
    },
    {
      path: "/reportes/aam_identificadores",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/reportes/aam_identificadores",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ReporteAAMIdentificadores.vue`
        )
    },
    {
      path: "/vucem/operaciones_virtuales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "operaciones_virtuales",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/vucem-pedimento/OperacionesVirtuales.vue`
        )
    },
    {
      path: "/cargar_facturastransito",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cargar_adjuntos_logistica",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/ecosting/CargaZipFacturasTransito.vue`
        )
    },
    {
      path: "/pedimento_uuid",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "pedimento_uuid",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/ecosting/ReportePedimetoUUID.vue`
        )
    },
    {
      path: "/facturastransito",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "facturastransito",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/ecosting/FacturasTransito.vue`
        )
    },
    {
      path: "/ordenesabiertas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ordenesabiertas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/OrdenesAbiertas.vue`
        )
    },
    {
      path: "/ecosting/referencia-pedimento",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ecosting/referencia-pedimento",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/ecosting/ReferenciaPedimentoFacturas.vue`
        )
    },
    {
      path: "/ordenesabiertascargar",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ordenesabiertascargar",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/CargarOrdenesAbiertas.vue`
        )
    },
    {
      path: "/videotutorial",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "videotutorial",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/VideoTutorial.vue`
        )
    },
    {
      path: "/recuperaciones_patente",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "recuperaciones_patente",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/edrive/RecuperacionesPatente.vue`
        )
    },
    {
      path: "/catalogos/contenido",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "contenido",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Contenido.vue`
        )
    },
    {
      path: "/catalogos/fondos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "fondos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Fondos.vue`
        )
    },
    {
      path: "/catalogos/terminospdf",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "terminospdf",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/TerminosPDF.vue`
        )
    },
    {
      path: "/diario",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "diario",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/DiarioOficial.vue`
        )
    },
    {
      path: "/anexo24",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "anexo24",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/Anexo24.vue`
        )
    },
    {
      path: "/reportes/a24",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "reportes_anexo24",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/ReportesA24.vue`
        )
    },
    {
      path: "/facturas_expediente",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "facturas_expediente",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/ecosting/FacturasExpediente.vue`
        )
    },
    {
      path: "/recuperaciones_coves",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "recuperaciones_coves",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/RecuperacionesCoves.vue`
        )
    },
    {
      path: "/recuperaciones_edocs",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "recuperaciones_edocs",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/RecuperacionesEdocs.vue`
        )
    },
    {
      path: "/mv_vistaprevia",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_vistaprevia",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/VistaPrevia.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/ubicaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_ubicaciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/carta_porte/catalogos/Ubicaciones.vue`
        )
    },
    {
      path: "/carta_porte/reportes/seguros",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_reporte_seguros",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/reportes/SegurosCartaPorte.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/transportes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_transportes",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/Transportes.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/figuras_transporte",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_figuras_transporte",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/FigurasTransporte.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/remolques",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_remolques",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/Remolques.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/clientes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_clientes",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/Clientes.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/productos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_productos",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/Articulos.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_materiales",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/Materiales.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/materiales_grupo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_materiales_grupo",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/MaterialesGrupo.vue`
        )
    },
    {
      path: "/carta_porte/catalogos/registro_fiscal",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_registro_fiscal",
      component: () =>
        import(
          `@/views/carta_porte/catalogos/RegistrosFiscales.vue`
        )
    },
    {
      path: "/carta_porte/administrar/totales_clientes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_totales_cliente",
      component: () =>
        import(
          `@/views/carta_porte/administracion/TotalesClientes.vue`
        )
    },
    {
      path: "/carta_porte/administrar/cartas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_cartas",
      component: () =>
        import(
          `@/views/carta_porte/administracion/CartaPorte.vue`
        )
    },

    {
      path: "/carta_porte/administrar/comercio",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_cartas",
      component: () =>
        import(
          `@/views/carta_porte/administracion/ComercioExterior.vue`
        )
    },
    {
      path: "/carta_porte/administrar/borradores",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_borradores",
      component: () =>
        import(
          `@/views/carta_porte/administracion/LayoutCartaPorte.vue`
        )
    },
    {
      path: "/carta_porte/administrar/borradores_refacturar",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_borradores_refacturar_carta_porte",
      component: () =>
        import(
          `@/views/carta_porte/administracion/BorradoresCartaPorteRefacturar.vue`
        )
    },
    {
      path: "/carta_porte/administrar/nueva_carta_refactura",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_nueva_carta_refactura",
      component: () =>
        import(
          `@/views/carta_porte/administracion/NewCartaPorteRefactura.vue`
        )
    },
    {
      path: "/carta_porte/administrar/nueva_carta_aereo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_nueva_carta_aereo",
      component: () =>
        import(
          `@/views/carta_porte/administracion/NewCartaPorteAereo.vue`
        )
    },
    {
      path: "/carta_porte/administrar/nueva_carta_ferroviaria",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_nueva_carta_ferroviaria",
      component: () =>
        import(
          `@/views/carta_porte/administracion/NewCartaPorteFerroviaria.vue`
        )
    },
    {
      path: "/carta_porte/administrar/borradoresce",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_borradores",
      component: () =>
        import(
          `@/views/carta_porte/administracion/LayoutComercioExterior.vue`
        )
    },
    {
      path: "/carta_porte/catalogos_sat/productos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "catalogos_sat/productos",
      component: () =>
        import(
          `@/views/carta_porte/catalogos_sat/ProductosServicios.vue`
        )
    },
    {
      path: "/carta_porte/catalogos_sat/materiales_peligrosos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "catalogos_sat/materiales_peligrosos",
      component: () =>
        import(
          `@/views/carta_porte/catalogos_sat/MaterialPeligroso.vue`
        )
    },
    {
      path: "/carta_porte/catalogos_sat/config_auto",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "catalogos_sat/config_auto",
      component: () =>
        import(
          `@/views/carta_porte/catalogos_sat/ConfigAutotransporte.vue`
        )
    },
    {
      path: "/carta_porte/catalogos_sat/ubicaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "catalogos_sat/ubicaciones",
      component: () =>
        import(
          `@/views/carta_porte/catalogos_sat/Ubicaciones.vue`
        )
    },
    {
      path: "/carta_porte/catalogos_sat/embalajes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "catalogos_sat/embalajes",
      component: () =>
        import(
          `@/views/carta_porte/catalogos_sat/Embalajes.vue`
        )
    },
    {
      path: "/carta_porte/administrar/nueva_carta",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_nueva_carta",
      component: () =>
        import(
          `@/views/carta_porte/administracion/NewCartaPorte.vue`
        )
    },
    {
      path: "/carta_porte/administrar/nueva_carta_maritima",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cp_nueva_carta_maritima",
      component: () =>
        import(
          `@/views/carta_porte/administracion/maritima/NewCartaPorteMaritima.vue`
        )
    },
    {
      path: "/carta_porte/administrar/comercio_exterior",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "comercio_exterior",
      component: () =>
        import(
          `@/views/carta_porte/administracion/NewComercioExterior.vue`
        )
    },
    {
      path: "/ce_cargazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_cargazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/CargaZipArchivoM.vue`
        )
    },
    {
      path: "/ce_bitacora",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_bitacora",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/BitacoraArchivoM.vue`
        )
    },
    {
      path: "/ce_expedientem",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_expedientem",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/ExpedienteArchivoM.vue`
        )
    },
    {
      path: "/ce_expediente_cfdi",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_expediente_cfdi",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/ExpedienteFacturas.vue`
        )
    },
    {
      path: "/ce_directom",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_directom",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/ReporteDirectoArchivoM.vue`
        )
    },
    {
      path: "/ce_facturastransito",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_facturastransito",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/BitacoraFacturas.vue`
        )
    },
    {
      path: "/ce_cargazipfacturas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_cargazipfacturas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/CargaZipFacturas.vue`
        )
    },
    {
      path: "/ce_reportedetalle",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_reportedetalle",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/ReporteFacturasDetallado.vue`
        )
    },
    {
      path: "/ce_reporteexterior",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "ce_reporteexterior",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/comercio_exterior/ReporteComercioExterior.vue`
        )
    },
    {
      path: "/mv_cargazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_cargazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/CargaZip.vue`
        )
    },
    {
      path: "/mv_cargamv",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_cargamv",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/CargaMV.vue`
        )
    },
     {
      path: "/mv_cargainc",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_cargainc",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/CargaINC.vue`
        )
    },
     {
      path: "/mv_cargava",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_cargava",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/CargaVA.vue`
        )
    },
     {
      path: "/mv_cargadec",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_cargadec",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/CargaDEC.vue`
        )
    },
     {
      path: "/mv_layouts",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_layouts",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/LayoutsManifestacion.vue`
        )
    },
    {
      path: "/mv_bitacora",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_bitacora",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/manifestacion_valor/Bitacora.vue`
        )
    },
    {
      path: "/mv_recuperaciones",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "mv_recuperaciones",
      component: () =>
        import(
          `@/views/manifestacion_valor/Recuperaciones.vue`
        )
    },
    {
      path: "/utilerias/cargaa24",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cargaa24",
      component: () =>
        import(
          `@/views/utilerias/CargaZipA24.vue`
        )
    },

    // Rutas de Grupo
    {
      path: "/grupo/datastage/cargazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/grupo/datastage/cargazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/datastage/CargaZipDSGrupo.vue`
        )
    },
    {
      path: "/grupo/datastage/bitacorazip",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/grupo/datastage/bitacorazip",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/datastage/BitacoraZipGrupo.vue`
        )
    },
    {
      path: '/grupo/catalogos/usuarios',
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: '/grupo/catalogos/usuarios',
      component: () => import(
        /* webpackChunkName: "routes" */
        `@/views/grupo/catalogos/UsuariosGrupo.vue`
      )
    },
    {
      path: "/grupo/reportes/consultar_pedimentos_detalle",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/consultar_pedimentos_detalle",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/vucem-pedimento/ConsultaPedimentoSimpleGrupo.vue`
        )
    },
    {
      path: "/grupo/vucem/lineas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/grupo/vucem/lineas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/vucem-pedimento/ConsultarLineasGrupo.vue`
        )
    },
    {
      path: "/grupo/datastage/directo_ds",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/grupo/datastage/directo_ds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/datastage/ReporteDirectoDSGrupo.vue`
        )
    },
    {
      path: "/grupo/reportes/activofijo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/activofijo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/reportes/ActivoFijoGrupo.vue`
        )
    },
    {
      path: "/grupo/reportes/operaciones_virtuales",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/operaciones_virtuales",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/reportes/OperacionesVirtualesGrupo.vue`
        )
    },
    {
      path: "/grupo/reportes/predeterminadosds",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/predeterminadosds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/reportes/PredeterminadosDSGrupo.vue`
        )
    },
    {
      path: "/grupo/reportes/predeterminadosws",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/predeterminadosws",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/reportes/PredeterminadosWSGrupo.vue`
        )
    },
    {
      path: "/grupo/reportes/rectificaciones",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/rectificaciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/reportes/RectificacionesGrupo.vue`
        )
    },
    {
      path: "/grupo/catalogos/acceso_usuarios",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/catalogos/acceso_usuarios",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/catalogos/AccesoUsuariosGrupo.vue`
        )
    },
    {
      path: "/grupo/catalogos/certificados",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/catalogos/certificados",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/catalogos/CertificadosGrupo.vue`
        )
    },
    {
      path: "/grupo/catalogos/aduanas",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/catalogos/aduanas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/catalogos/AduanasGrupo.vue`
        )
    },
    {
      path: "/grupo/catalogos/patentes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/catalogos/patentes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/catalogos/CertificadosPatenteGrupo.vue`
        )
    },
    {
      path: "/grupo/catalogos/representantes",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/catalogos/representantes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/catalogos/RepresentantesGrupo.vue`
        )
    },
    {
      path: "/grupo/catalogos/firmas",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/catalogos/firmas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/catalogos/FirmasGrupo.vue`
        )
    },
    {
      path: "/grupo/reportes/identificadoresgrupo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/grupo/reportes/identificadoresgrupo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/grupo/reportes/IdentificadoresComplementosGrupo.vue`
        )
    },
    //SOLUCIONA 31
    {
      path: "/sa31/datastage/predeterminados/roce",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/datastage/predeterminados/roce",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/ROCEDS.vue`
        )
    },
    {
      path: "/sa31/datastage/predeterminados/preferencias_arancelarias",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/datastage/predeterminados/preferencias_arancelarias",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/PreferenciasArancelariasDS.vue`
        )
    },
    {
      path: "/sa31/catalogos/reglas_plazo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/catalogos/reglas_plazo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/ReglasPlazo.vue`
        )
    },
    {
      path: "/sa31/cargartxt",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/cargartxt",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/CargarTXT.vue`
        )
    },
    {
      path: "/sa31/auditorias/cargosds",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/cargosds",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/ValidacionCargosDS.vue`
        )
    },
    {
      path: "/sa31/auditorias/abonos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/contronta_abonos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/Abonos.vue`
        )
    },
    {
      path: "/sa31/auditorias/abonos_cargos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/abonos_cargos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/ReporteadorCargosAbonos.vue`
        )
    },
    {
      path: "/sa31/auditorias/confronta_clave",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/confronta_clave",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/AuditoriaClaveDocumento.vue`
        )
    },
    {
      path: "/sa31/auditorias/inve_inicial",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/inve_inicial",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/InventarioInicial.vue`
        )
    },
    {
      path: "/sa31/auditorias/computo_plazos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/computo_plazos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/ComputoPlazos.vue`
        )
    },
    {
      path: "/sa31/auditorias/fracciones_periodos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/fracciones_periodos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/auditorias/FraccionesPeriodos.vue`
        )
    },
    {
      path: "/sa31/reportes/abonos_fracciones",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/abonos_fracciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/AbonosFracciones.vue`
        )
    },
    {
      path: "/sa31/reportes/abonos_folio",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/abonos_folio",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/AbonosFolio.vue`
        )
    },
    {
      path: "/sa31/reportes/abonos_referencia_pedimento",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/abonos_referencia_pedimento",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/AbonosReferenciaPedimentos.vue`
        )
    },
    {
      path: "/sa31/reportes/abonos_referencia_documentos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/abonos_referencia_documentos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/AbonosReferenciaDocumentos.vue`
        )
    },
    {
      path: "/sa31/reportes/abonos_referencia_partidas",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/abonos_referencia_partidas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/AbonosReferenciaPartidas.vue`
        )
    },
    {
      path: "/sa31/reportes/saldos_fracciones",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/saldos_fracciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/SaldosFracciones.vue`
        )
    },
    {
      path: "/sa31/reportes/proximo_periodo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/proximo_periodo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/ProximoPeriodo.vue`
        )
    },
    {
      path: "/sa31/reportes/fueraplazo",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/fueraplazo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/FueraPlazo.vue`
        )
    },
    {
      path: "/sa31/reportes/novalidos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/novalidos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/NoValidos.vue`
        )
    },
    {
      path: "/sa31/reportes/cuentat_fraccion",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/cuentat_fraccion",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/CuentaTFraccion.vue`
        )
    },
    {
      path: "/sa31/reportes/partidas_inicial",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/partidas_inicial",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/PartidasInventarioInicial.vue`
        )
    },
    {
      path: "/sa31/reportes/saldos_bimestral",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/saldos_bimestral",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/SaldosBimestral.vue`
        )
    },
    {
      path: "/sa31/cargarinicial",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/cargarinicial",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/CargarInicial.vue`
        )
    },
    {
      path: "/indexsa31",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },
          {
            role: "Soporte",
            access: false,
            redirect: "listaclientes"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "indexsa31",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/IndexSa31.vue`
        )
    },
    {
      path: "/sa31/bitacora",
      meta: {
        permissions: [


          {
            role: "Super Usuario",
            access: (user, to) => user.id_cliente > 0,
            redirect: "admin"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "sa31/bitacora",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/Bitacora.vue`
        )
    },
    {
      path: "/sa31/papelera",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: (user, to) => user.id_cliente > 0,
            redirect: "admin"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "sa31/papelera",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/Papelera.vue`
        )
    },
    {
      path: "/sa31/simulacion",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: (user, to) => user.id_cliente > 0,
            redirect: "admin"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "sa31/simulacion",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/Simulacion.vue`
        )
    },
    {
      path: "/sa31/catalogos/claves_distintas",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: (user, to) => user.id_cliente > 0,
            redirect: "admin"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "sa31/catalogos/claves_distintas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/ClavesDistintas.vue`
        )
    },
    {
      path: "/sa31/indexar",
      meta: {
        permissions: [

          {
            role: "Super Usuario",
            access: true,
            redirect: "admin"
          },

          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "sa31/indexar",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/PedimentosXLS.vue`
        )
    },
    {
      path: "/sa31/reportes/cargos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/cargos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/Cargos.vue`
        )
    },
    {
      path: "/sa31/reportes/cargos_partidas",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/cargos_partida",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/CargosPartida.vue`
        )
    },
    {
      path: "/sa31/generador_archivos",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/generador_archivos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/GeneradorArchivos.vue`
        )
    },
    {
      path: "/sa31/buscar_pedimento",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/buscar_pedimento",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/BuscarPedimento.vue`
        )
    },
    {
      path: "/sa31/reportes/estado_cuenta_global",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/estado_cuenta_global",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/EstadoCuentaGlobal.vue`
        )
    },
    {
      path: "/sa31/reportes/estado_cuenta_fracciones",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/estado_cuenta_fracciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/EstadoCuentaFracciones.vue`
        )
    },
    {
      path: "/sa31/reportes/importar",
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ],
      },
      name: "/sa31/importar",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/sa31/reportes/ImportarCargos.vue`
        )
    },
    {
      path: "/sa24/cat_activo_fijo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/cat_activo_fijo",
      component: () =>
        import(
          `@/views/soluciona24/CatActivoFijo.vue`
        )
    },
    {
      path: "/sa24/rpt_cat_activo_fijo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_cat_activo_fijo",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCatActivoFijo.vue`
        )
    },
    {
      path: "/sa24/consulta_cat_activo_fijo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_cat_activo_fijo",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaCatActivoFijo.vue`
        )
    },
    {
      path: "/sa24/cat_materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/cat_materiales",
      component: () =>
        import(
          `@/views/soluciona24/CatMateriales.vue`
        )
    },
    {
      path: "/sa24/rpt_cat_materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_cat_materiales",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCatMateriales.vue`
        )
    },
    {
      path: "/sa24/consulta_cat_materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_cat_materiales",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaCatMateriales.vue`
        )
    },
    {
      path: "/sa24/cat_lista_materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/cat_lista_materiales",
      component: () =>
        import(
          `@/views/soluciona24/CatListaMateriales.vue`
        )
    },
    {
      path: "/sa24/rpt_cat_lista_materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_cat_lista_materiales",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCatListaMateriales.vue`
        )
    },
    {
      path: "/sa24/consulta_cat_lista_materiales",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_cat_lista_materiales",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaCatListaMateriales.vue`
        )
    },
    {
      path: "/sa24/cat_productos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/cat_productos",
      component: () =>
        import(
          `@/views/soluciona24/CatProductos.vue`
        )
    },
    {
      path: "/sa24/rpt_cat_productos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_cat_productos",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCatProductos.vue`
        )
    },
    {
      path: "/sa24/consulta_cat_productos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_cat_productos",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaCatProductos.vue`
        )
    },
    {
      path: "/sa24/activo_fijo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/activo_fijo",
      component: () =>
        import(
          `@/views/soluciona24/ActivoFijo.vue`
        )
    },
    {
      path: "/sa24/rpt_activo_fijo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_activo_fijo",
      component: () =>
        import(
          `@/views/soluciona24/ReporteActivoFijo.vue`
        )
    },
    {
      path: "/sa24/consulta_activo_fijo",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_activo_fijo",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaActivoFijo.vue`
        )
    },
    {
      path: "/sa24/descargos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/descargos",
      component: () =>
        import(
          `@/views/soluciona24/Descargos.vue`
        )
    },
    {
      path: "/sa24/rpt_descargos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_descargos",
      component: () =>
        import(
          `@/views/soluciona24/ReporteDescargos.vue`
        )
    },
    {
      path: "/sa24/consulta_descargos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_descargos",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaDescargos.vue`
        )
    },
    {
      path: "/sa24/entradas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/entradas",
      component: () =>
        import(
          `@/views/soluciona24/Entradas.vue`
        )
    },
    {
      path: "/sa24/rpt_entradas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_entradas",
      component: () =>
        import(
          `@/views/soluciona24/ReporteEntradas.vue`
        )
    },
    {
      path: "/sa24/consulta_entradas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_entradas",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaEntradas.vue`
        )
    },
    {
      path: "/sa24/saldos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/saldos",
      component: () =>
        import(
          `@/views/soluciona24/Saldos.vue`
        )
    },
    {
      path: "/sa24/rpt_saldos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_saldos",
      component: () =>
        import(
          `@/views/soluciona24/ReporteSaldos.vue`
        )
    },
    {
      path: "/sa24/resumen_cfdi_ctm",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/resumen_cfdi_ctm",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCTMResumenCFDIaCTM.vue`
        )
    },
    {
      path: "/sa24/rpt_ctm_eficiencia_ligue",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/eficiencia_ligue",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCTMEficienciaLigue.vue`
        )
    },
    {
      path: "/sa24/rpt_cfdi_ligue_ctm",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/cfdi_ligue_ctm",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCFDILigueCTM.vue`
        )
    },
    {
      path: "/sa24/rpt_ctm_cfdi_valor_detalle",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/cfdi_valor_detalle",
      component: () =>
        import(
          `@/views/soluciona24/ReporteCTMCfdiValorDetalle.vue`
        )
    },
    {
      path: "/sa24/consulta_saldos",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_saldos",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaSaldos.vue`
        )
    },
    {
      path: "/sa24/salidas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/salidas",
      component: () =>
        import(
          `@/views/soluciona24/Salidas.vue`
        )
    },
    {
      path: "/sa24/rpt_salidas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_salidas",
      component: () =>
        import(
          `@/views/soluciona24/ReporteSalidas.vue`
        )
    },
    {
      path: "/sa24/consulta_salidas",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_salidas",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaSalidas.vue`
        )
    },
    {
      path: "/sa24/ctm",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/ctm",
      component: () =>
        import(
          `@/views/soluciona24/CTM.vue`
        )
    },
    {
      path: "/sa24/consulta_ctm",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/consulta_ctm",
      component: () =>
        import(
          `@/views/soluciona24/ConsultaCTM.vue`
        )
    },
    {
      path: "/sa24/domicilios",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/domicilios",
      component: () =>
        import(
          `@/views/soluciona24/Domicilios.vue`
        )
    },
    {
      path: "/sa24/rpt_ped_faltantes",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/rpt_ped_faltantes",
      component: () =>
        import(
          `@/views/soluciona24/AuditoriaPedimentosFaltantes.vue`
        )
    },
    {
      path: "/sa24/saldo_inicial_ctm",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "/sa24/saldo_inicial_ctm",
      component: () =>
        import(
          `@/views/soluciona24/SaldoInicial.vue`
        )
    },
    //DVC COVE
    {
      path: "/anam/dvc",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "anam-dvc",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/anam/DVC.vue`
        )
    },
    {
      path: "/anam/digitalizados",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "anam-digitalizados",
      component: () =>
        import(
          `@/views/anam/Digitalizados.vue`
        )
    },
    {
      path: "/cfdi/consulta",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cfdi-consulta",
      component: () =>
        import(
          `@/views/cfdi/Admin.vue`
        )
    },
    {
      path: "/cfdi/fiel",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "cfdi-fiel",
      component: () =>
        import(
          `@/views/cfdi/Fiel.vue`
        )
    },
    {
      path: "/sa24/memoriactm",
      meta: {
        permissions: [
          {
            role: 'guest',
            access: false,
            redirect: 'login',
          },
        ],
        breadcrumb: true
      },
      name: "memoriactm",
      component: () =>
        import(
          `@/views/soluciona24/MemoriaCTM.vue`
        )
    },
  ]
});



router.beforeEach((to, from, next) => {
  let perfil = localStorage.getItem('id_perfil')
  if(perfil != null && perfil != '' && perfil != undefined && perfil === '66') {
    let to_route = to.path
    let id_user = localStorage.getItem('id_usuario')
    let selected_rfc = localStorage.getItem('rfc')
    let selected_mail = localStorage.getItem('email')

    axios.post('https://api.econnectpro.mx/vucem/logs_views/', { id_usuario: id_user, view: to_route, rfc: selected_rfc, email: selected_mail })
      .then(response => {
      }).catch(error => {
      })
  }
  window.urlreferrer = from.path;

  NProgress.start();
  next();



})
router.afterEach((to, from) => {
  store.state.current_url = to.path;
  NProgress.done();

});

export default router;
